import { useCallback } from "react";
import apiClient from "../axiosClient";
import {
  CampaignPreset,
  CreateCampaignPresetBody,
} from "./types";

export function useGetCampaignPresetApi() {
  return useCallback(
    (
      presetId: string,
      companyId: string
    ): Promise<{ data: CampaignPreset }> =>
      apiClient.get(`/applications/campaign-presets/${presetId}`, {
        params: { companyId },
      }),
    []
  );
}

export function useCreateCampaignPresetApi() {
  return useCallback(
    (body: CreateCampaignPresetBody, companyId: string) =>
      apiClient.post(`/applications/campaign-presets`, body, { params: { companyId } }),
    []
  );
}

export function useUpdateCampaignPresetApi() {
  return useCallback(
    (
      presetId: string,
      body: { name: string; description: string },
      companyId: string
    ): Promise<{ data: CampaignPreset }> =>
      apiClient.patch(`/applications/campaign-presets/${presetId}`, body, {
        params: { companyId },
      }),
    []
  );
}

export function useSetCampaignPresetStatusApi() {
  return useCallback(
    (presetId: string, status: string, companyId: string) =>
      apiClient.patch(
        `/applications/campaign-presets/${presetId}/status`,
        { status },
        { params: { companyId } }
      ),
    []
  );
}

export function useRecordCampaignPresetOriginApi() {
  return useCallback(
    (campaignId: string, presetId: string, companyId: string) =>
      apiClient.put(
        `/campaigns/${campaignId}/preset-origin`,
        { presetId },
        { params: { companyId } }
      ),
    []
  );
}

export function useSetCampaignPresetFavoriteApi() {
  return useCallback(
    (presetId: string, companyId: string) =>
      apiClient.put<void>(`/applications/campaign-presets/${presetId}/favorite`, null, {
        params: { companyId },
      }),
    []
  );
}

export function useUnsetCampaignPresetFavoriteApi() {
  return useCallback(
    (presetId: string, companyId: string) =>
      apiClient.delete<void>(`/applications/campaign-presets/${presetId}/favorite`, {
        params: { companyId },
      }),
    []
  );
}
